export interface CardPaymentDetails {
  kind: 'creditcard';
  cardType: string;
  cardNumber: string;
  cvc: string;
  expDate: ExpiryDate;
  cardHolderName: string;
  paymentFrequency: 4; // Once (One-Off)
  dateToDonateInMonth: string;
  startDonationFrom: ExpiryDate;
  sagePayMerchantSessionKey?: string;
  sagePayCardIdentifier?: string;
}

export const DefaultCreditCardPaymentDetails: CardPaymentDetails = {
  kind: 'creditcard',
  cardType: '',
  cardNumber: '',
  cvc: '',
  expDate: { month: '', year: '' },
  cardHolderName: '',
  paymentFrequency: 4,
  dateToDonateInMonth: '',
  startDonationFrom: { month: '', year: '' }
};

export interface ExpiryDate {
  month: string;
  year: string;
}

export const PaymentErrorMessages = 'There was a problem with your donation, please try again. If the problem persists please try an alternative card.';



// WEBPACK FOOTER //
// ./src/Types/Payments/PaymentDetails.ts